import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "m9 8 4-4m-4 9.5 3-3M15.5 7l-1.625 1.625M9 18.5l1.875-1.875M16.5 11l-3.75 3.75M9 21c4.418 0 8-3.646 8-8.143 0-4.462-2.553-9.67-6.537-11.531A3.45 3.45 0 0 0 9 1m0 20c-4.418 0-8-3.646-8-8.143C1 11.27 1.323 9.59 1.917 8M9 21V1m0 0c-.5 0-.999.109-1.463.326-1.601.748-2.97 2.036-4.037 3.6"
    }, null, -1)
  ]))]))
}
export default { render: render }